import clsx from 'clsx'

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean
  shouldDebounce?: boolean
}

export default function ColorPicker({
  className,
  invalid = false,
  ...rest
}: Props) {
  return (
    <label
      className={clsx(
        'flex cursor-pointer flex-row items-center gap-2 rounded-small border border-text bg-white px-4 py-2 text-regular text-text placeholder:text-text-light focus-within:outline-solid focus-within:outline-primary',
        invalid && 'border-red-500',
        className
      )}
    >
      <div className="relative size-5 overflow-hidden rounded-xxsmall">
        <input
          {...rest}
          type="color"
          aria-invalid={invalid}
          className="absolute inset-1/2 size-10 -translate-x-1/2 -translate-y-1/2 appearance-none border-none bg-transparent p-0"
        />
      </div>
      {rest.value && typeof rest.value === 'string' && (
        <span>{rest.value.toUpperCase()}</span>
      )}
      {!rest.value && (
        <span className="text-text-light">{rest.placeholder}</span>
      )}
    </label>
  )
}
